import { RestrictionStatus } from 'dataSources/Typicode/stations';
import {
  AvailabilityType,
  FuelType,
} from 'pages/Map/components/FuelAvailabilityButton/constants';

const makeRestrictionsPayload = ({
  fuel,
  availability,
  statuses,
}: {
  fuel: FuelType | string;
  availability: AvailabilityType;
  statuses: Array<RestrictionStatus>;
}) => {
  if (fuel) {
    return {
      restrictions: {
        serviceNtType: fuel,
        mode: availability,
        statuses,
      },
    };
  } else {
    return {};
  }
};

export default makeRestrictionsPayload;
